import axios from "axios";

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const MAIN_SLUG = "ajude-o-instituto-petlovers-a-cuidar-de-centenas-de-patinhas";

export const IMAGES = {
  hero: "https://static.prod-images.emergentagent.com/jobs/d02d7f4d-84a0-46d1-bcd7-897c1950be33/images/5986ace02340dd1478db13d47e48d8f6a5a7b6ff5af085c169fd0fa8f7e38f1f.jpeg",
};

export const api = axios.create({ baseURL: API_BASE });

export const formatBRL = (cents) =>
  (Number(cents || 0) / 100).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

export const fetchCampaigns = async () => (await api.get("/campaigns")).data;
export const fetchCampaign = async (slug) => (await api.get(`/campaigns/${slug}`)).data;
export const createDonation = async (slug, payload) =>
  (await api.post(`/campaigns/${slug}/donations`, payload)).data;
export const getDonation = async (donationId) => (await api.get(`/donations/${donationId}`)).data;
export const simulateDonation = async (donationId) =>
  (await api.post(`/donations/${donationId}/simulate`)).data;
